export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return !['Y'].includes(sampleStatus) || !!sampleSetCode
    },
  },
  {
    text: that.$l('btn_tips_copy') || '复制',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'C',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return ['N'].includes(sampleStatus) || !!sampleSetCode
    },
  },
  {
    text: that.$l('btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ sampleStatus, sampleSetCode, inputSource }) => {
      return !['Y'].includes(sampleStatus) || !!sampleSetCode || inputSource == 'MINIAPP'
    },
  },
  {
    text: that.$l('btn_tips_recovery') || '还原',
    icon: 'el-icon-refresh-left',
    menuType: 'reduction',
    allow: 'R',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return sampleStatus !== 'N' || !!sampleSetCode
    },
  },
  {
    text: that.$l('btn_tips_audit') || '审核产品',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'T',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return !['Y'].includes(sampleStatus) || !!sampleSetCode
    },
  },
  {
    text: that.$l('menu_text_audit_edit') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'submitEdit',
    allow: 'I',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return sampleStatus !== 'S' || !!sampleSetCode
    }
  },
  {
    text: that.$l('menu_text_rejected') || '驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'P',
    disabled: ({ sampleStatus, sampleSetCode }) => {
      return sampleStatus !== 'S' || !!sampleSetCode
    }
  },
]
